define(function (require) {
	const tpl = require('./templates/t_lov_detail_grid.hbs');
	const GridView = require('./v_cpv_grid_table');

	const IpsModel = require('civicsBase/ipsModel');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const ModalRegion = require('civicsUtils/modal_region');
	const ModalConfirmation = require('civicsViews/confirmation_modal/v_lov_confirmation_modal');

	const DetailObjectModel = require('civicsModels/core/detail_object_model');

	return Marionette.LayoutView.extend({
		template: tpl,
		regions: {
			modalEntryRegion: {
				regionClass: ModalRegion,
				selector: 'body .rhythm-modals'
			},
			gridRegion: '@ui.grid'
		},
		FILTERCODEMODELID: '',
		ui: {
			addRowButton: '.btn-row-add',
			grid: '.grid-region',
			gridWrapper:'.grid-wrapper'
		},
		events: {
			'click @ui.addRowButton': 'addRowClicked'
		},
		childEvents: {
			'deleteRowButtonClicked': 'deleteRow',
			'editRowButtonClicked':'editRow'
		},
		//Marionette Functions Start
		initialize: function (options) {
			this.gridMoniker = this.model.get('moniker');
			this.gridBind = this.model.get('bind');
			this.elements = this.model.get('elements');
			this.config = $.extend({},options.config);
			this.config.canEditExistingRows = ((this.model.get('canEdit')) == undefined ? true : this.model.get('canEdit'))  && !this.config.readOnlyForm && this.model.get('isEnabled');
			this.config.canAddRows = ((this.model.get('canAdd') == undefined) ? true : this.model.get('canAdd')) && !this.config.readOnlyForm && this.model.get('isEnabled');
			this.config.canDeleteExistingRows = ((this.model.get('canDelete')) == undefined ? true : this.model.get('canDelete')) && !this.config.readOnlyForm && this.model.get('isEnabled');
			this.config.gridField = true;
			this.config.isEnabled = this.model.get('isEnabled');
			this.name = this.model.get('bind');
			this.moniker = options.moniker;
			this.values = options.values;
			this.rows = this.getRows();
			if (!this.config.readOnlyForm) {
				this.rows.on('change add remove update reset', this.displayGridRows.bind(this));
			}
		},
		onShow: function () {
			this.displayGridRows();
			if (this.gridMoniker === undefined) {
				this.addIsForGridMoniker();
			}
		},
		templateHelpers: function () {
			return {
				canAddRows: this.config.canAddRows,
				gridMoniker: this.gridMoniker
			};
		},
		//End Marionette Functions
		addRowClicked: function () {
			var values = {};
			values[this.getGridKeyBind()] = this.generateGridKey();
			this.modalGridEntryView = new this.config.detailsConstructor({
				config: this.config,
				//if we pass in this.model.elements directly, we end up setting values on our source of truth. This results in
				//values from a previously entered row showing up in a new row modal.
				collection: new IpsModelCollection(this.model.get('elements').toJSON()),
				isModal: true,
				grid: this, //pass in a reference to this view for the modal to refer to when passing data back.
				values: values,
				newRow:true,
				moniker: this.moniker
			});
			this.modalEntryRegion.show(this.modalGridEntryView);
			this.modalEntryRegion.showModal();
		},
		deleteRow: function (childView, model) {
			var confModal = new ModalConfirmation({
				title: i18n.t('CIVICS.INSTRUMENT_SUBMIT.DELETE_ROW_CONFIRMATION_TITLE'),
				instructions: i18n.t('CIVICS.INSTRUMENT_SUBMIT.DELETE_ROW_CONFIRMATION_TEXT'),
				submitButtonText: i18n.t('CIVICS.COMMON.DELETE'),
				confirmationCallback: () => {
					this.rows.remove(model);
					//no need to send a delete for newly created rows. jsut remove from grid collection and move on.
					if (model.get('_newRow') != true) {
						if (this.rowsToDelete == null) {
							this.rowsToDelete = [];
						}

						var deleteModel = new DetailObjectModel();
						deleteModel.set('aggregaterootbind', this.gridBind);
						deleteModel.idAttribute = this.getGridKeyBind();
						deleteModel.set(deleteModel.idAttribute, model.get(deleteModel.idAttribute));
						deleteModel.moniker = this.gridMoniker;
						this.rowsToDelete.push(deleteModel);
					}
					this.modalEntryRegion.empty();
				}
			});
			this.modalEntryRegion.empty();
			this.modalEntryRegion.show(confModal);
			this.modalEntryRegion.showModal();
		},
		displayGridRows: function () {
			if (this.gridView != null) {
				this.gridRegion.empty();
			}
			//Note the clone - we're not passing in the original object
			//for whatever reason this.model.clone() throws a stack size exceeded error, so doing this manually.
			var gridElements = new IpsModel(this.model.toJSON());
			gridElements.get('elements').add({
				type: 'edit'
			},
			{
				at: 0
			});
			gridElements.get('elements').add({
				type: 'delete'
			},
			{
				at: 0
			});
			this.gridView = new GridView({
				config: this.config,
				collection: this.rows,
				model: gridElements
			});
			this.gridRegion.show(this.gridView);
			this.updateEditDeleteCSS();
		},
		editRow: function (childView, model) {

			var modalGridEntryView = new this.config.detailsConstructor({
				config: this.config,
				collection: new IpsModelCollection(this.model.get('elements').toJSON()),
				isModal: true,
				grid: this, //pass in a reference to this view for the modal to refer to when passing data back.
				values: model,
				editingRow: true
			});
			this.modalEntryRegion.show(modalGridEntryView);
			this.modalEntryRegion.showModal();
			this.setupFilterCodes(this.model.get('moniker'));
		},
		//when adding a row to a grid, we need to adda  unique key to each rows. Rows from the server should already have keys, and therefore won't need this.
		generateGridKey: function () {
			var gridKeyBind = this.getGridKeyBind();
			var key = 0;
			var exists = this.rows.models.length > 0;
			var found = false;
			//loop until exists is false. We'll set this to false when we make it through the rows without finding key
			while (exists) {
				for (var i = 0; i < this.rows.models.length; i++) {
					if (this.rows.models[i].get(gridKeyBind) == key) {
						found = true;
						key++;
						break;
					}
				}
				if (!found) {
					exists = false;
				} else {
					//reset the found check and try again.
					found = false;
				}
			}
			//So, because the number 0 is the equivalent to false in JS/handlebars, we need to make sure to return a string here.
			//a number field with a value of 0 will not have a value set, but a number field with a value of "0" will. Yay JS.
			return key.toString();
		},
		getData: function () {
			return this.gridView.getData();
		},
		getDeletedRows: function () {
			return this.rowsToDelete;
		},
		//we have to iterate over the columns in a grid to find the key column. It really should be the first column, but the "isKeyValue" attribute will always be true regardless.
		getGridKeyBind: function () {
			if (this.gridKeyBind) {
				return this.gridKeyBind;
			}
			var bind = '';
			if (this.model) {
				var els = this.model.get('elements');
				var gridColumns = els.models ? els.models : [];
				$.each(gridColumns, function (index, el) {
					if (el.get('isKeyValue') === true) {
						bind = el.get('bind');
						//break out of $.each
						return false;
					}
				});
			}
			this.gridKeyBind = bind;
			return bind;
		},
		getRows: function () {
			var idAttr = this.getGridKeyBind();
			//we need a collection that uses the grid key as the ID.
			var rowCollection = IpsModelCollection.extend({
				idAttr: idAttr,
				modelId: function (attrs) {
					return attrs[idAttr];
				}
			});
			var rows = new rowCollection();
			if (this.values && this.values.get(this.name)){
				var vals = this.values.get(this.name);
				if (vals.models) {
					//if we don't change this to JSON, changes to the row data trickle up to other views and cause rerenders.
					var json = vals.toJSON();
					rows.set(json);
				} else if (Array.isArray(vals)) {
					rows.set(vals);
				}
			}
			return rows;
		},
		saveRowClicked: function (rowData) {
			this.rows.set(rowData, { remove: false });
		},
		//The edit and delete buttons are displayed outside of the grid via negative absolute positioning. To accomodate that,
		//the grid is shifted right the appropriate numebr of pixels. When a grid has no rows, even if the edit/delete permissions are allowed,
		//this margin shouldn't show. So as rows are added or removed, we need to update the css for the table. We do this by simply adding
		//a 'show-delete-button' and 'show-edit-button' class to the grid wrapper div. This needs to be done on load, since we may be loading
		//in rows, and on delete and edit.
		updateEditDeleteCSS: function () {
			var showEdit = this.config.canEditExistingRows;
			var showDelete = this.config.canDeleteExistingRows;

			if (this.rows.length > 0) {
				//If we have rows, but edit and delete are true anyways, there's no point in going through the rows to check if we have new rows.
				//New rows can always be deleted or edited. So Even though the table might not allow that for EXISTING rows, if we have new rows we have to
				//update the CSS to show the buttons for thows rows.
				if ((!showEdit || !showDelete)) {
					$.each(this.rows.models, (index,model) => {
						if (model.get('_newRow')) {
							showEdit = true;
							showDelete = true;
						}
					});
				}
			} else {
				//hide the edit/delete columns if there are no rows so the table isn't shifted right for no apparent reason
				showEdit = false;
				showDelete = false;
			}
			if (showEdit) {
				this.ui.gridWrapper.addClass('show-edit-margin');
			} else {
				this.ui.gridWrapper.removeClass('show-edit-margin');
			}

			if (showDelete) {
				this.ui.gridWrapper.addClass('show-delete-margin');
			} else {
				this.ui.gridWrapper.removeClass('show-delete-margin');
			}
		},
		addIsForGridMoniker: function(){
			var $parentDetailPage = this.ui.gridWrapper.closest(".detail-view-box");

			if ($parentDetailPage && $parentDetailPage.length === 1) {
				var parentMoniker = $parentDetailPage.attr("data-detailpagemoniker");
				if (parentMoniker && parentMoniker.endsWith("Collection")) {
					var isForGridMoniker = parentMoniker.substr(0, parentMoniker.length - 10);
					this.ui.gridWrapper.attr("data-gridmoniker", isForGridMoniker);
					this.gridMoniker = isForGridMoniker;
					this.moniker = isForGridMoniker;
				}
			}
		}
	});
});
